import AOS from "aos";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import MapInformation from "../../components/NaverMap";
import * as S from "./styled";

const ContactUs = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  useEffect(() => {
    if (window.naver) return;

    const script = document.createElement("script");
    script.src =
      "https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=lfq42znk8e";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://neptunedance.com" />
        <meta
          property="og:image"
          content="http://neptunedance.com/og-image.png"
        />
      </Helmet>
      <S.ContactUsWrapper>
        <div className="inner">
          <S.ContactUsWrap>
            <div
              className="img-area"
              data-aos="fade"
              data-aos-duration={500}
              data-aos-easing="linear"
            >
              <MapInformation latitude={37.4824144} longitude={126.9729156} />
              {/* <img src={MapImage} alt="mapImg" className="pc-image" />
            <img src={MapMobImage} alt="mapImg" className="mo-image" /> */}
            </div>
            <div className="text-area">
              <div
                data-aos="fade-left"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <h6 className="title">상담/문의</h6>
                <div className="text-item">
                  <span>학원 전화번호</span>
                  <p>010-2351-8784</p>
                </div>
                <div className="text-item">
                  <span>학원 운영시간</span>
                  <p>
                    평일 2:00 PM - 10:00 PM <br />
                    주말 10:00 AM - 4:00 PM <br />
                    금요일 휴무
                  </p>
                </div>
                <NavLink
                  to="http://pf.kakao.com/_xdxcJZn"
                  target="_blank"
                  className="kakao-btn"
                >
                  카카오 채널 문의하기
                </NavLink>
              </div>

              <div
                data-aos="fade-left"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <h6 className="title">오시는 길</h6>
                <div className="text-item">
                  <p>넵튠 댄스 스튜디오</p>
                  <p className="grey-text">
                    서울 동작구 사당로16길 28 3층
                    <br />- 7호선 남성역 1번출구 도보 3분 -
                  </p>
                </div>
                <div className="text-item">
                  <span>주차 안내</span>
                  <p>남성역 공영주차장</p>
                  <p className="grey-text">
                    도보 2분 거리의 남성역 공영주차장을 이용해주세요
                    <br />
                    (건물 주차 불가)
                  </p>
                </div>
              </div>
            </div>
          </S.ContactUsWrap>
        </div>
      </S.ContactUsWrapper>
    </>
  );
};

export default ContactUs;
